<template>
    <div class="detail">
        <el-dialog title="商品详情" :visible.sync="dialogVisible" width="996px" :before-close="handleClose">
            <div class="content" v-loading="load">
                <el-table ref="singleTable" :data="tableDataD" style="width: 100%" @selection-change="handleSelectionChange" border>
                    <el-table-column type="selection" width="55" :selectable="checkSelect"> </el-table-column>
                    <el-table-column prop="id" label="商品ID" width="80" align="center"> </el-table-column>
                    <el-table-column prop="title" label="商品名称" align="center">
                        <template slot-scope="scope">
                            <el-tooltip v-if="scope.row.title && scope.row.title.length > 8" :content="scope.row.title" placement="top" effect="light">
                                <span>{{ scope.row.title | countFmt }}</span>
                            </el-tooltip>
                            <span v-else>{{ scope.row.title | countFmt }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="goods_specifications_type_id" label="规格类型" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.goods_specifications_type_id == 1 ? "单规格" : "多规格" }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="price" label="销售价" align="center">
                        <template slot-scope="scope">
                            <p>{{ scope.row.prices_mains }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="merchandise_inventory" label="库存" align="center"> </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <div>
                    <el-button type="primary" @click="postProduct" plain>确 定</el-button>
                </div>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
    data() {
        return {
            dialogVisible: false,
            tableDataD: [],
            load: false,
            btnLoad: false,
            multipleSelection: [],
            true: 0,
        };
    },
    props: {
        skuData: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
    filters: {
        countFmt(val) {
            if (val) {
                if (val.length >= 8) {
                    return val.substring(0, 8) + "...";
                }
                return val;
            }
            return "-";
        },
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    created() {},
    methods: {
        ...mapActions({
            getProductDetail: "activity/getProductDetail",
        }),
        postProduct() {
            this.$emit("postProduct", this.spuId, this.multipleSelection);
            this.handleClose()
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        getList(id) {
            this.load = true;
            let params = {
                token: this.getToken,
                spuId: id,
            };
            this.getProductDetail(params).then(({ data }) => {
                this.load = false;
                if (data.code == 1) {
                    this.spuId = data.data.id;
                    this.tableDataD = data.data.sku_data;
                    if (this.tableDataD && this.tableDataD.length > 0) {
                        this.$nextTick(() => {
                            this.tableDataD.forEach((item, index) => {
                                let flag = this.skuData.some((val) => {
                                    return val.skuId == item.id;
                                });
                                this.$refs.singleTable.toggleRowSelection(item, flag);
                            });
                        });
                    }
                } else {
                    this.$message.error(data.code);
                }
            });
        },
        checkSelect(row, index) {
            if (row.activity_name == "") {
                // 判断里面是否存在某个参数
                return 1;
            } else {
                return 0;
            }
        },
        // 关闭
        handleClose() {
            this.dialogVisible = false;
            this.tableDataD = [];
            this.multipleSelection = [];
            this.spuId = 0;
        },
    },
};
</script>
<style lang="scss" scoped>
.detail {
    .content {
        ::v-deep .el-table__body-wrapper {
            height: 400px !important;
            overflow-y: auto;
        }
    }
    ::v-deep .el-table__body-wrapper {
        border-bottom: none;
    }
    ::v-deep .el-table::before {
        display: none;
    }
    ::v-deep .el-input-number {
        width: 140px;
    }
}
.price {
    display: flex;
    justify-content: space-between;
    .el-input-group {
        width: 48%;
    }
}
</style>